import { render, staticRenderFns } from "./PictureWithLink.vue?vue&type=template&id=63d24391&scoped=true&"
import script from "./PictureWithLink.vue?vue&type=script&lang=ts&"
export * from "./PictureWithLink.vue?vue&type=script&lang=ts&"
import style0 from "./PictureWithLink.vue?vue&type=style&index=0&id=63d24391&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d24391",
  null
  
)

export default component.exports